import React from "react";
import { useSelector } from 'react-redux';
import { getFullOSName } from "../../utils/misc/system";
import { Loader, UserCircle, Laptop, IdCard } from "lucide-react";
import { Badge } from "../ui/badge";

const UserHeader = () => {
  const { userData, userDataisLoading } = useSelector(state => state.UserStatus);
  const isOnline = userData?.isOnline;
  
  return (
    <div className="flex flex md:flex-row flex-col items-center gap-4">
      <div className="relative">
        <div className="bg-gray-100 h-16 w-16 rounded-full flex items-center justify-center">
          { userDataisLoading && (<Loader className="h-10 w-10 animate-spin"/>)}
          {!userDataisLoading && (<UserCircle className="h-10 w-10 text-gray-500" />)}
        </div>
        <div className="absolute -bottom-1 -right-1">
          <Badge
            variant={isOnline ? "success" : "outline"}
            className="rounded-full px-2 text-xs"
          >
            {isOnline ? "Online" : "Offline"}
          </Badge>
        </div>
      </div>
      <div>
        <h1 className="text-2xl font-bold">{userData?.email || 'Public User'}</h1>
        <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <IdCard className="h-4 w-4" />
            <span className="text-xs">GUID: {userData?.guid || '--'}</span>
          </div>
          { userData?.lastOperatingSystem && (<div className="flex items-center gap-1">
            <Laptop className="h-4 w-4" />
            <span>{getFullOSName(userData.lastOperatingSystem)}</span>
          </div>)}
          { userData?.lastChromebookSerial && (<div className="flex items-center gap-1">
            <span className="hidden sm:inline">•</span>
            <span>S/N: {userData?.lastChromebookSerial}</span>
          </div>)}
          <div className="flex items-center gap-1">
            <span className="hidden sm:inline">•</span>
            <span>Last Restart: {userData?.lastRestartTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHeader;
